/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { authChallengeAdminGet } from '../fn/auth/auth-challenge-admin-get';
import { AuthChallengeAdminGet$Params } from '../fn/auth/auth-challenge-admin-get';
import { authChallengeAdminPost } from '../fn/auth/auth-challenge-admin-post';
import { AuthChallengeAdminPost$Params } from '../fn/auth/auth-challenge-admin-post';
import { authChallengePersonalGet } from '../fn/auth/auth-challenge-personal-get';
import { AuthChallengePersonalGet$Params } from '../fn/auth/auth-challenge-personal-get';
import { authChallengePersonalPost } from '../fn/auth/auth-challenge-personal-post';
import { AuthChallengePersonalPost$Params } from '../fn/auth/auth-challenge-personal-post';
import { authGet } from '../fn/auth/auth-get';
import { AuthGet$Params } from '../fn/auth/auth-get';
import { authLoginAdminPost } from '../fn/auth/auth-login-admin-post';
import { AuthLoginAdminPost$Params } from '../fn/auth/auth-login-admin-post';
import { authLoginGet } from '../fn/auth/auth-login-get';
import { AuthLoginGet$Params } from '../fn/auth/auth-login-get';
import { authLoginPersonalPost } from '../fn/auth/auth-login-personal-post';
import { AuthLoginPersonalPost$Params } from '../fn/auth/auth-login-personal-post';
import { authLogoutGet } from '../fn/auth/auth-logout-get';
import { AuthLogoutGet$Params } from '../fn/auth/auth-logout-get';
import { authTokenGet } from '../fn/auth/auth-token-get';
import { AuthTokenGet$Params } from '../fn/auth/auth-token-get';

@Injectable({ providedIn: 'root' })
export class AuthService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `authGet()` */
  static readonly AuthGetPath = '/auth';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  authGet$Response(params?: AuthGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return authGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authGet(params?: AuthGet$Params, context?: HttpContext): Observable<void> {
    return this.authGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `authLoginGet()` */
  static readonly AuthLoginGetPath = '/auth/login';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authLoginGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  authLoginGet$Response(params?: AuthLoginGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return authLoginGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authLoginGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authLoginGet(params?: AuthLoginGet$Params, context?: HttpContext): Observable<void> {
    return this.authLoginGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `authLoginPersonalPost()` */
  static readonly AuthLoginPersonalPostPath = '/auth/login-personal';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authLoginPersonalPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  authLoginPersonalPost$Response(params?: AuthLoginPersonalPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return authLoginPersonalPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authLoginPersonalPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authLoginPersonalPost(params?: AuthLoginPersonalPost$Params, context?: HttpContext): Observable<void> {
    return this.authLoginPersonalPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `authChallengePersonalGet()` */
  static readonly AuthChallengePersonalGetPath = '/auth/challenge-personal';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authChallengePersonalGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  authChallengePersonalGet$Response(params?: AuthChallengePersonalGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return authChallengePersonalGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authChallengePersonalGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authChallengePersonalGet(params?: AuthChallengePersonalGet$Params, context?: HttpContext): Observable<void> {
    return this.authChallengePersonalGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `authChallengePersonalPost()` */
  static readonly AuthChallengePersonalPostPath = '/auth/challenge-personal';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authChallengePersonalPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  authChallengePersonalPost$Response(params?: AuthChallengePersonalPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return authChallengePersonalPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authChallengePersonalPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authChallengePersonalPost(params?: AuthChallengePersonalPost$Params, context?: HttpContext): Observable<void> {
    return this.authChallengePersonalPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `authLoginAdminPost()` */
  static readonly AuthLoginAdminPostPath = '/auth/login-admin';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authLoginAdminPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  authLoginAdminPost$Response(params?: AuthLoginAdminPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return authLoginAdminPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authLoginAdminPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authLoginAdminPost(params?: AuthLoginAdminPost$Params, context?: HttpContext): Observable<void> {
    return this.authLoginAdminPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `authChallengeAdminGet()` */
  static readonly AuthChallengeAdminGetPath = '/auth/challenge-admin';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authChallengeAdminGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  authChallengeAdminGet$Response(params?: AuthChallengeAdminGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return authChallengeAdminGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authChallengeAdminGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authChallengeAdminGet(params?: AuthChallengeAdminGet$Params, context?: HttpContext): Observable<void> {
    return this.authChallengeAdminGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `authChallengeAdminPost()` */
  static readonly AuthChallengeAdminPostPath = '/auth/challenge-admin';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authChallengeAdminPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  authChallengeAdminPost$Response(params?: AuthChallengeAdminPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return authChallengeAdminPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authChallengeAdminPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authChallengeAdminPost(params?: AuthChallengeAdminPost$Params, context?: HttpContext): Observable<void> {
    return this.authChallengeAdminPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `authTokenGet()` */
  static readonly AuthTokenGetPath = '/auth/token';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authTokenGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  authTokenGet$Response(params?: AuthTokenGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return authTokenGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authTokenGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authTokenGet(params?: AuthTokenGet$Params, context?: HttpContext): Observable<void> {
    return this.authTokenGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `authLogoutGet()` */
  static readonly AuthLogoutGetPath = '/auth/logout';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authLogoutGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  authLogoutGet$Response(params?: AuthLogoutGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return authLogoutGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authLogoutGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authLogoutGet(params?: AuthLogoutGet$Params, context?: HttpContext): Observable<void> {
    return this.authLogoutGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
